import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbRightArrow: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 14, ...props }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} fill={fill} {...props}>
      <g id='Box'>
        <rect fill={'none'} width='24' height='24' />
      </g>
      <g id='Final_icons_-_Common' data-name='Final icons - Common'>
        <polygon fill={fill} points='14 4 12.5 5.5 18 11 2 11 2 13 18 13 12.5 18.5 14 20 22 12 14 4' />
      </g>
    </svg>
  );
};
